import ChartColors from '../../../../js/utility/ChartColors';
import {CubeMeasure, CubeMember, RenderContext} from '../types';

export const MISSING_COLOR = '#909090';

export function itemColor(
    member: CubeMember | undefined,
    measure: CubeMeasure | undefined,
    index: number,
    ctx: RenderContext,
): string {
    if (member?.color) {
        return member.color;
    }
    if (member?.role === 'total') {
        return ChartColors.COLOR_TOTAL;
    }
    if (member?.role === 'missing') {
        return MISSING_COLOR;
    }
    return measure?.color ?? ctx.palette[index % ctx.palette.length];
}
